import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import { register } from "./service-worker-register";
import ErrorBoundary from "./components/ErrorBoundary";
import { installGlobalClientErrorReporter } from "./utils/clientErrorReporter";
// 요구사항 #286 — document capture 단계에서 markIgnoreUntil 활성 동안 모든 click 차단
import { installGlobalClickIgnoreGuard } from "./utils/clickGuard";

// 글로벌 JS error / Promise rejection → 서버 보고
installGlobalClientErrorReporter();
installGlobalClickIgnoreGuard();

// 요구사항 #277-1 — PWA 설치 시 portrait 강제 (manifest 의 orientation 보강)
// Chromium 기반 (Android Chrome, Edge) 에서 screen.orientation API 사용
try {
  const so = (window.screen as Screen & {
    orientation?: { lock?: (o: string) => Promise<void> };
  }).orientation;
  if (so && typeof so.lock === "function") {
    so.lock("portrait").catch(() => { /* 권한 없을 시 silent */ });
  }
} catch { /* 미지원 브라우저 */ }

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

register();
